import React, { useState } from 'react';
import { Bell, Check, X, Music } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const NotificationDropdown = ({ suggestions, onAccept, onReject }) => {
  const [open, setOpen] = useState(false);
  const unreadCount = suggestions.length;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="relative border-violet-300 hover:bg-violet-50"
        >
          <Bell className="w-5 h-5 text-violet-600" />
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-xs font-bold text-white">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      
      <DropdownMenuContent 
        className="w-80 max-h-96 overflow-y-auto bg-white border-gray-200 shadow-lg"
        align="end"
      >
        <div className="p-3 border-b border-gray-200">
          <h3 className="font-semibold text-gray-900">
            Suggestions invités
          </h3>
          <p className="text-xs text-gray-500 mt-1">
            {unreadCount} {unreadCount > 1 ? 'nouvelles' : 'nouvelle'}
          </p>
        </div>

        {suggestions.length === 0 ? (
          <div className="p-6 text-center">
            <Bell className="w-12 h-12 text-violet-200 mx-auto mb-3" />
            <p className="text-sm text-gray-500">
              Aucune suggestion en attente
            </p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100">
            {suggestions.map((suggestion) => (
              <div
                key={suggestion.id}
                className="p-4 hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-start gap-3 mb-3">
                  <Music className="w-4 h-4 text-violet-500 mt-1 flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 truncate">
                      {suggestion.requested_title || 'Titre inconnu'}
                    </p>
                    <p className="text-xs text-gray-500 truncate">
                      {suggestion.requested_artist || 'Artiste inconnu'}
                    </p>
                    {suggestion.guest_name && (
                      <p className="text-xs text-gray-400 mt-1">
                        Par : {suggestion.guest_name}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex gap-2">
                  <Button
                    onClick={() => {
                      onAccept(suggestion.id);
                      setOpen(false);
                    }}
                    size="sm"
                    className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Check className="w-3 h-3 mr-1" />
                    Accepter
                  </Button>
                  <Button
                    onClick={() => {
                      onReject(suggestion.id);
                    }}
                    size="sm"
                    variant="outline"
                    className="flex-1 border-red-300 text-red-600 hover:bg-red-50"
                  >
                    <X className="w-3 h-3 mr-1" />
                    Refuser
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NotificationDropdown;
